/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// modules
import auth from './modules/auth'
//import chat from './modules/chat'
import settings from './modules/settings'
//import ecommerce from './modules/ecommerce'
//import mail from './modules/mail'
import sidebar from './modules/sidebar'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        httpRunning: false,
        errorList: []
    },
    getters: {
        errorList: state => {
            return state.errorList;
        }
    },
    mutations: {
        startHttpRunning(state) { state.httpRunning = true },
        stopHttpRunning(state) { state.httpRunning = false },
        addError(state, error) {
            state.errorList.unshift(error)
        },
        clearErrors(state) { state.errorList = [] }
    },
    modules: {
        auth,
        // chat,
        settings,
        // ecommerce,
        // mail,
        sidebar
    },
    plugins: [createPersistedState({
        reducer: function (state, paths) {
            return { auth: state.auth }
        }
    })]
})
